import { formatUserSettingsValue } from './formatUserSettingsValue';
export function formatFetchUserSettingsResponse(rawSettings) {
  return {
    attributes: Object.entries(rawSettings).map(([key, value]) => ({
      key,
      value: formatUserSettingsValue(value)
    }))
  };
}